import service from '@/middleware'

const farmApi = {
    /**
     * Datos para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} headers
     * @param {*} enterpriseIds
     */
    async findAll(pageSize, pageNumber, headers, enterpriseIds) {
        const url = `/api/farm/all?pageSize=${pageSize}&pageNumber=${pageNumber}&headers=${headers}`
        const response = await service.http.post(url, enterpriseIds)
        return response
    },
    /**
     * Total de grupos para el paginador de la tabla del ABM
     * @param {*} enterpriseIds
     */
    async getTotal (enterpriseIds) {
        const result = await service.http.post(`/api/farm/total`, enterpriseIds)
        return result
    },
    /**
     * Para validar el nombre de un grupo
     * @param {*} name
     * @param {*} enterpriseId
     */
    async validateFarmName (name, enterpriseId) {
        const result = await service.http.get(`/api/farm/validate-name/${name}/${enterpriseId}`)
        return result
    },
    /**
     * Para crear un nuevo grupo
     * @param {*} farmDto
     * @param {*} thingIds
     */
    async create (farmDto) {
        const result = await service.http.post(`/api/farm/create`, { farmDto })
        return result
    },
    /**
     * Para actualizar un grupo
     * @param {*} farmDto
     * @param {*} thingIds
     */
    async update (farmDto) {
        const result = await service.http.put(`/api/farm/update`, { farmDto })
        return result
    },
    /**
     * Para eliminar un grupo
     * @param {*} enterpriseId
     * @param {*} farmId
     */
    async deleteOne (enterpriseId, farmId) {
        await service.http.delete(`/api/farm/${enterpriseId}/${farmId}`)
    },
    /**
     * Eliminación múltiple
     * @param {*} deletes
     */
    async deleteMany (deletes) {
        await service.http.put(`/api/farm/multiple-delete`, deletes)
    },
    /**
     * Obtener las fincas para una empresa
     * @param {*} enterpriseId 
     */
    async findForSelector (enterpriseId) {
        const result = await service.http.get(`/api/farm/for-selector`, { params: { enterpriseId } })
        return result
    },

    /**
     * Verificar si una finca puede ser eliminada
     * Devuelve true si no está asociada a ninguna unidad ecologica
     * @param {*} enterpriseId
     * @param {*} farmId
     */
    async canDeleteFarm (enterpriseId, farmId) {
        const result = await service.http.get(`/api/farm/can-delete/${enterpriseId}/${farmId}`)
        return result
    },

    /**
     * Verificar si un arreglo de fincas puede ser eliminada
     * Devuelve true si ninguna se encuentra está asociada a una unidad ecologica
     * @param {*} idsToDelete
     */
    async canDeleteFarms (idsToDelete) {
        const result = await service.http.post('/api/farm/can-delete', { idsToDelete })
        return result
    }
}

export default farmApi
